<app-cascading-modal>
    <app-modal [title]="'Reset Password Email'">

        <a #modalShow ngProjectAs="modal-show" class="text-center font-medium text-link text-nowrap" (click)="cascadingModal()?.start()">Forgot Password ?</a>

        <div #modalContent ngProjectAs="modal-content">

            <div class="mb-4">
                <p class="font-light">The email inserted below will receive an email with a link to reset your password.</p>
            </div>

            <form [formGroup]="form" (ngSubmit)="onRequestEmail()">
                
                <app-form-control [(control)]="form.controls.usernameOrEmail" [type]="'text'"/>

                <app-modal-form-button-group [buttons]="['submit']" [form]="form.controls.usernameOrEmail"
                    [opts]="{
                        values:{
                            submit: 'Send'
                        }
                    }" 
               />

            </form>    
        </div>

    </app-modal>

    <app-modal [title]="'Reset Code'">

        <div #modalContent ngProjectAs="modal-content">

            <div class="mb-4">
                <p class="font-light">Insert below the 6-digit code you've received in your email.</p>
            </div>

            <form [formGroup]="form">
                
                <app-form-control-underline [(control)]="form.controls.code" [length]="6" [type]="'number'"/>                

                <app-modal-form-button-group [buttons]="['next']" [form]="form.controls.code" (next)="cascadingModal()?.next()"/>

            </form>    
        </div>

    </app-modal>

    <app-modal [title]="'Change Password'">

        <div #modalContent ngProjectAs="modal-content">

            <div class="mb-4">
                <p class="font-light">Enter and confirm your new password below.</p>
            </div>

            <form [formGroup]="form" (ngSubmit)="onSubmit()">
        
                <app-form-control [(control)]="form.controls.passwords.controls.newPassword" [type]="'password'"/>
                <app-form-control [(control)]="form.controls.passwords.controls.confirmPassword" [type]="'password'"/>
            
                <app-modal-form-button-group [buttons]="['back', 'submit']" [form]="form" (back)="cascadingModal()?.back()"
                    [opts]="{
                        values:{
                            submit: 'Change'
                        }
                    }" 
               />
        
            </form>  
        </div>

    </app-modal>
    
</app-cascading-modal>